// Utility function to constrain image dimensions while maintaining aspect ratio
export const constrainImageDimensions = (
  originalWidth,
  originalHeight,
  maxWidth = 600,
  maxHeight = 600
) => {
  // If both dimensions are within limits, return original
  if (originalWidth <= maxWidth && originalHeight <= maxHeight) {
    return {
      width: originalWidth,
      height: originalHeight,
    };
  }

  // Calculate aspect ratio
  const aspectRatio = originalWidth / originalHeight;

  let newWidth, newHeight;

  // Determine which dimension is the limiting factor
  if (originalWidth / maxWidth > originalHeight / maxHeight) {
    // Width is the limiting factor
    newWidth = maxWidth;
    newHeight = Math.round(maxWidth / aspectRatio);
  } else {
    // Height is the limiting factor
    newHeight = maxHeight;
    newWidth = Math.round(maxHeight * aspectRatio);
  }

  return {
    width: newWidth,
    height: newHeight,
  };
};

// Helper function to get constrained dimensions from itemsImgArray
export const getConstrainedDimensions = (
  itemsImgArray,
  itemId,
  defaultWidth = 600,
  defaultHeight = 300
) => {
  if (itemsImgArray[itemId]) {
    const original = itemsImgArray[itemId];
    return constrainImageDimensions(original.width, original.height);
  }

  // Return constrained default dimensions
  return constrainImageDimensions(defaultWidth, defaultHeight);
};
